import React from "react";
import styled from 'styled-components';

const ModalContainer = styled.div`
  display: flex;
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
  background-color: rgba(51,51,51, 0.5);
  justify-content: center;
  align-items: center;
  z-index: 400;
  overflow-y: auto;
`;

class ModalWrapper extends React.PureComponent {

  render() {
    return <ModalContainer>{this.props.children}</ModalContainer>
  }
}

export default ModalWrapper;
